import { Text } from 'react-native';
import playerEmptyObject from './playerEmptyObject';
import allStatsForGame from './allStatsForGame';
import { eventMessages }  from './matchMessages';
import styles from './inGameStyles'

const partido = (data, team1Id, team2Id, lang, props = { state: 0 }) => {
	//states
	//0 undefined, no sabemos
	//1 liga
	//2 copa
	//3 multijugador

	//strategies
	const strategies = [
		data.others.inmatchStates.strategy,
		{
			beaTacDef: Math.floor(Math.random() * (3) + (1)),
			beaTacOff: Math.floor(Math.random() * (3) + (1)),
			beaters: Math.floor(Math.random() * (3) + (1)),
			changes: Math.floor(Math.random() * (3) + (1)),
			notUsed: Math.floor(Math.random() * (3) + (1)),
			chasers: Math.floor(Math.random() * (3) + (1)),
			keepTac: Math.floor(Math.random() * (3) + (1)),
			seekTac: Math.floor(Math.random() * (3) + (1))
		}
	]

	//todo
	//meteorologia del dia
	const meteorology = {
		wind: 40,
		rain: 20,
		temperature: 20,
		fog: 10
	}

	let felixFelicis = [0, 0]
	if (props.state != 3 && props.state != 0) {
		if (data.others.inmatchStates && data.others.inmatchStates.felixFelicis) {
			console.log("felix felicis activado")
			//felixfelicis es 90 porque es la suerte con la que se empieza, tendrá entre 90 y 99 de suerte si tiene felixfelicis activado
			felixFelicis[0] = 90
			data.others.inmatchStates.felixFelicis = false;
		}

		if (data.others.inmatchStates && data.others.inmatchStates.confundus) {
			//todo
		}
	}
	//return [data,[<Text>No</Text>,<Text>se</Text>,<Text>juega</Text>,<Text>partido</Text>,<Text>hoy</Text>],[150,150]]
	team1Id = team1Id - 1
	team2Id = team2Id - 1
	let info = [];
	//posesion en false es 0, asi que la bola la tiene el equipo local, o el primer equipo, o mi equipo
	//la p es de posesion, pues es mas corto decir p y aunque pierda sentido, se entiende y las lineas son mas cortas
	let finPartido = false, p = false, jugadas = 0, puntuacion = [0, 0], suplentesEnElCampo = [false,false];

	//en banquilloDeLesiones, el primer hueco es para el jugador y el segundo para la posición de la que se le ha despachado
	let saveStatsInjured = [[{},{},{},{},{},{},{}],[{},{},{},{},{},{},{}]]

	//diccionario de lesiones (y de everything, cuando no se juega liga/copa) para otros partidos que no sean ni liga ni copa (si un jugador ya estaba lesionado, aqui se guarda)
	let unofficialDictionary = [[{},{},{},{},{},{},{},{},{},{},{},{},{},{}],[{},{},{},{},{},{},{},{},{},{},{},{},{},{}]]

	//14 jugadores (21 en la vida real) en cada equipo, para hacer bien los cambios
	let teams = [
		JSON.parse(JSON.stringify(data.teams[team1Id])),
		JSON.parse(JSON.stringify(data.teams[team2Id]))
	]
	teams[0].players = teams[0].players.slice(0, 14);
	teams[1].players = teams[1].players.slice(0, 14);
	let teamsStats = [
		JSON.parse(JSON.stringify(data.teams[team1Id])),
		JSON.parse(JSON.stringify(data.teams[team2Id]))
	]
	teamsStats[0].players = teamsStats[0].players.slice(0, 14);
	teamsStats[1].players = teamsStats[1].players.slice(0, 14);

	for (let i = 0; i < 2; i++) {
		for (let j = 0; j < 14; j++) {
			//se miran que los jugadores existan
			if (teams[i].players[j]) {
				if (props.state != 1 && props.state != 2) {
					//no es oficial, guardamos en unofficial cada jugador
					const ply = {savedStats: teams[i].players[j].stats, savedInjury: teams[i].players[j].injury}
					unofficialDictionary[i][j] = ply
				}
			} else {
				teams[i].players[j] = playerEmptyObject("FAN RANDOM");
			}
	
			//reset inGameStats
			teamsStats[i].players[j].inGameStats = allStatsForGame()
		}
	}

	//para que el titulo y los nombres de los equipos no se solapen
	info.push(<Text style={styles.textCenter}><Text style={styles.matchTeam}>{teams[0].name}</Text> vs <Text style={styles.matchTeam}>{teams[1].name}</Text></Text>)
	info.push(getRandomEventMessage('gameStarts', teams, p, -1, -1, lang));
	info.push(<Text>{"\n"}</Text>)

	//ahora comprobamos que los titulares estan sanos
	for (let i = 0; i < 7; i++) {
		if (teamsStats[0].players[i].injury > 0) {
			[info, teams[0], teamsStats[0], saveStatsInjured] = substitutePlayer(info, teams, i, teamsStats[0], saveStatsInjured, 0, lang, true)
		}
		if (teamsStats[1].players[i].injury > 0) {
			[info, teams[1], teamsStats[1], saveStatsInjured] = substitutePlayer(info, teams, i, teamsStats[1], saveStatsInjured, 1, lang, true)
		}
	}

	//saque inicial, a ver quien coje la bola
	const x = getAverageByParameters(teams[0].players[5], [0, 0.1, 1, 0.4, 0, 0, 0], [0.1, 0, 0], [0.1, 0.1], 0.2, felixFelicis[0])
	const y = getAverageByParameters(teams[1].players[5], [0, 0.1, 1, 0.4, 0, 0, 0], [0.1, 0, 0], [0.1, 0.1], 0.2, felixFelicis[1])
	if (checkWhoWins(x, y)) p = true;

	info.push(getRandomEventMessage('initialJumpBall', teams, p, 5, -1, lang));
	info.push(<Text>{"\n"}</Text>)

	//cada loop es una jugada, por un equipo o por otro, da igual
	do {
		//0 guardian, 1 2 lanzandores, 3 4 5 cazadores y 6 buscador
		//vamos a atacar, 'x' siempre sera el equipo que ataque, 'y' el que defienda
		//para atacar, atacaran los 6, pero los cazadores seran mas importantes
		//probabilidad de llegar a la porteria, y una vez alli, probabilidad de meter el tiro

		//la idea es que la jugada se divida en 3, el medio campo de tu equipo (facil de pasar), el medio campo del contrario (mas dificil), y el tiro a puerta

		//declaramos las habilidades de nuestro equipo
		let xs = [0, 0, 0, 0, 0, 0, 0], ys = [0, 0, 0, 0, 0, 0, 0]
		let aboutFault = {
			isFault: false,
			injury: 0,
			isPenalty: false,
			isFlagrant: false,
			isExpulsion: false,
			info: []
		};
		let theBludgers = [
			{itHits:false,itSaves:false,teamThatGetsHit:!p,whichBeaterHits:0,whichBeaterSaves:0,causesInjury:0,whoGetsHit:0},
			{itHits:false,itSaves:false,teamThatGetsHit:!p,whichBeaterHits:0,whichBeaterSaves:0,causesInjury:0,whoGetsHit:0}
		]


		//MEDIO CAMPO 1

		//coeficientes, pues se necesitan en variables para ver quien chuta/defiende
		let coefAttack = [0, 0, 0, 0, 0, 0, 0]
		let coefDefense = [0, 0, 0, 0, 0, 0, 0]

		//guardian
		//vamos a ver si el portero sube la bola o no
		xs[0] = getAverageByParameters(teams[p + 0].players[0], [0.15, 0.025, 1, 0, 0, 0.25, 0.025], [0, 0.05, 0.2], [0, 0.1], 0.2, felixFelicis[p + 0])
		if (strategies[p + 0].keepTac == 2) coefAttack[0] = 0.2
		else if (strategies[p + 0].keepTac == 1) coefAttack[0] = 0.1
		else if (strategies[p + 0].keepTac == 3) coefAttack[0] = 0
		xs[0] = coefAttack[0] * xs[0]

		//cazador 1, 2 y 3
		xs[3] = getAverageByParameters(teams[p + 0].players[3], [0.1, 0.025, 1, 0, 0, 0.3, 0.025], [0, 0.05, 0.2], [0, 0.1], 0.2, felixFelicis[p + 0])
		xs[4] = getAverageByParameters(teams[p + 0].players[4], [0.1, 0.025, 1, 0, 0, 0.3, 0.025], [0, 0.05, 0.2], [0, 0.1], 0.2, felixFelicis[p + 0])
		xs[5] = getAverageByParameters(teams[p + 0].players[5], [0.1, 0.025, 1, 0, 0, 0.3, 0.025], [0, 0.05, 0.2], [0, 0.1], 0.2, felixFelicis[p + 0])
		if (strategies[p + 0].chasers == 3) coefAttack = [coefAttack[0], 0, 0, 0.9, 0.8, 0.3]
		else if (strategies[p + 0].chasers == 1) coefAttack = [coefAttack[0], 0, 0, 0.85, 0.6, 0.2]
		else if (strategies[p + 0].chasers == 2) coefAttack = [coefAttack[0], 0, 0, 0.8, 0.4, 0.1]
		xs[3] = coefAttack[3] * xs[3]
		xs[4] = coefAttack[4] * xs[4]
		xs[5] = coefAttack[5] * xs[5]

		//contrarios
		//cazador 3 y 2
		ys[5] = getAverageByParameters(teams[!p + 0].players[5], [0, 0.1, 1, 0.15, 0, 0.2, 0], [0, 0.1, 0.1], [0.15, 0], 0.2, felixFelicis[!p + 0])
		ys[4] = getAverageByParameters(teams[!p + 0].players[4], [0, 0.1, 1, 0.15, 0, 0.2, 0], [0, 0.1, 0.1], [0.15, 0], 0.2, felixFelicis[!p + 0])
		if (strategies[!p + 0].chasers == 2) coefDefense = [0, 0, 0, 0, 0.6, 0.9]
		else if (strategies[!p + 0].chasers == 1) coefDefense = [0, 0, 0, 0, 0.4, 0.75]
		else if (strategies[!p + 0].chasers == 3) coefDefense = [0, 0, 0, 0, 0.2, 0.6]
		ys[5] = coefDefense[5] * ys[5]
		ys[4] = coefDefense[4] * ys[4]

		//bludger x2
		//miramos bludger (2 veces, pero lo hace dentro)
		theBludgers = bludgerViene(teams, p, felixFelicis, strategies);
		[info, teamsStats] = bludgerStatsAndTexts(theBludgers[0], info, teamsStats, teams, saveStatsInjured, lang);
		if(theBludgers[0].itHits && !theBludgers[0].itSaves){
			if (theBludgers[0].teamThatGetsHit) xs[theBludgers[0].whoGetsHit] = 0;
			else ys[theBludgers[0].whoGetsHit] = 0;
		}

		//se enfrentan, sumamos y comparamos
		let xsum = (xs[0] + xs[3] + xs[4] + xs[5]) * 4;
		let ysum = ys[5] + ys[4];

		if (checkWhoWins(xsum, ysum)) {
			//MEDIO CAMPO 2

			//miramos si hay falta en ataque
			const whoCarriesBall = quienRobaElBalon(xs, [0, 3, 4, 5]) ?? 0;
			const whatEnemyIsVictim = quienRobaElBalon(ys, [5, 4]) ?? 0;
			aboutFault = checkFault(teams[p + 0].players[whoCarriesBall], teams[!p + 0].players[whatEnemyIsVictim], true);

			[info, puntuacion, teams, teamsStats] = faultStatsAndTexts(info, p, puntuacion, aboutFault, teams, whatEnemyIsVictim, whoCarriesBall, teamsStats, felixFelicis, saveStatsInjured, lang, true);

			//p = !p

			if (!aboutFault.isFault) {
				teamsStats[p + 0].players[whoCarriesBall].stats.progressions++;
				teamsStats[p + 0].players[whoCarriesBall].inGameStats.progressions++;

				//cazadores 1, 2 y 3
				xs[3] = getAverageByParameters(teams[p + 0].players[3], [0.2, 0.05, 1, 0.1, 0, 0.1, 0], [0.2, 0.05, 0.05], [0, 0.05], 0.2, felixFelicis[p + 0])
				xs[4] = getAverageByParameters(teams[p + 0].players[4], [0.2, 0.05, 1, 0.1, 0, 0.1, 0], [0.2, 0.05, 0.05], [0, 0.05], 0.2, felixFelicis[p + 0])
				xs[5] = getAverageByParameters(teams[p + 0].players[5], [0.2, 0.05, 1, 0.1, 0, 0.1, 0], [0.2, 0.05, 0.05], [0, 0.05], 0.2, felixFelicis[p + 0])
				if (strategies[p + 0].chasers == 3) coefAttack = [0, 0, 0, 0.1, 0.2, 0.7]
				else if (strategies[p + 0].chasers == 1) coefAttack = [0, 0, 0, 0.15, 0.4, 0.8]
				else if (strategies[p + 0].chasers == 2) coefAttack = [0, 0, 0, 0.2, 0.6, 0.9]
				xs[3] = coefAttack[3] * xs[3]
				xs[4] = coefAttack[4] * xs[4]
				xs[5] = coefAttack[5] * xs[5]

				//contrarios
				//cazadores 3, 2 y 1
				ys[5] = getAverageByParameters(teams[!p + 0].players[5], [0, 0.2, 1, 0.15, 0, 0.025, 0.125], [0, 0.1, 0.05], [0.15, 0], 0.2, felixFelicis[!p + 0])
				ys[4] = getAverageByParameters(teams[!p + 0].players[4], [0, 0.2, 1, 0.15, 0, 0.025, 0.125], [0, 0.1, 0.05], [0.15, 0], 0.2, felixFelicis[!p + 0])
				ys[3] = getAverageByParameters(teams[!p + 0].players[3], [0, 0.2, 1, 0.15, 0, 0.025, 0.125], [0, 0.1, 0.05], [0.15, 0], 0.2, felixFelicis[!p + 0])
				if (strategies[!p + 0].chasers == 2) coefDefense = [0, 0, 0, 1, 0.4, 0.1]
				else if (strategies[!p + 0].chasers == 1) coefDefense = [0, 0, 0, 1, 0.6, 0.25]
				else if (strategies[!p + 0].chasers == 3) coefDefense = [0, 0, 0, 1, 0.8, 0.4]
				ys[5] = coefDefense[5] * ys[5]
				ys[4] = coefDefense[4] * ys[4]
				ys[3] = coefDefense[3] * ys[3]

				//guardian contrario
				ys[0] = getAverageByParameters(teams[!p + 0].players[0], [0, 0.2, 1, 0.15, 0, 0, 0.1], [0, 0.15, 0.1], [0.1, 0], 0.2, felixFelicis[!p + 0])
				if (strategies[!p + 0].keepTac == 2) coefDefense[0] = 0.2
				else if (strategies[!p + 0].keepTac == 1) coefDefense[0] = 0.1
				else if (strategies[!p + 0].keepTac == 3) coefDefense[0] = 0
				ys[0] = coefDefense[0] * ys[0]

				//bludger x2
				theBludgers = bludgerViene(teams, p, felixFelicis, strategies);
				[info, teamsStats] = bludgerStatsAndTexts(theBludgers[0], info, teamsStats, teams, saveStatsInjured, lang);
				if(theBludgers[0].itHits && !theBludgers[0].itSaves){
					if (theBludgers[0].teamThatGetsHit) xs[theBludgers[0].whoGetsHit] = 0;
					else ys[theBludgers[0].whoGetsHit] = 0;
				}

				xsum = (xs[3] + xs[4] + xs[5]) * 4;
				ysum = ys[5] + ys[4] + ys[3] + ys[0];

				if (checkWhoWins(xsum, ysum)) {
					//LANZAMIENTO A PORTERIA 3

					//se crea coefAttAndPrecision por que la precision de los jugadores importa. Si un jugador tira mejor, intentarán pasarle la bola a el y que el realice el tiro a puerta
					//no ocurre en asistencias, pues cualquiera puede tener la bola antes del momento del gol

					//primero miramos quien chuta
					//cazadores 1, 2 y 3
					let whoThrows = quienRobaElBalon(xs, [3, 4, 5]) ?? 0;

					//miramos quien comete falta (si es que comete, claro)
					let whoDefends = quienRobaElBalon(ys, [5, 4, 3, 0]) ?? 0;

					//miramos si hay falta
					aboutFault = checkFault(teams[!p + 0].players[whoDefends], teams[p + 0].players[whoThrows]);

					[info, puntuacion, teams, teamsStats] = faultStatsAndTexts(info, p, puntuacion, aboutFault, teams, whoDefends, whoThrows, teamsStats, felixFelicis, saveStatsInjured, lang);

					//p = !p

					info.push(getRandomEventMessage('beforeShot', teams, p, whoThrows, -1, lang));

					if (!aboutFault.isFault) {
						//y ahora miramos quien asiste (si asiste el mismo, es regate)
						let whoAssists = quienRobaElBalon(xs, [3, 4, 5]) ?? 0;

						//es un bucle porque puede haber rebote
						//una vez entra en el bucle ya se sabe quien lleva la bola (y como ha llegado a sus manos)

						let bolaMoviendose = true;
						do {
							//LANZAMIENTO A PUERTA

							xs[whoThrows] = getAverageByParameters(teams[p + 0].players[whoThrows], [0.35, 0, 1, 0.15, 0, 0, 0], [0, 0.1, 0.1], [0.05, 0.05], 0.2, felixFelicis[p + 0])
							ys[0] = getAverageByParameters(teams[!p + 0].players[0], [0, 0.35, 1, 0.1, 0, 0, 0], [0, 0.15, 0.15], [0, 0.05], 0.2, felixFelicis[!p + 0])

							//se divide entre 4 el contrario en vez de multiplicar por 4 el amigo, para que las cualidades del portero sean algo mas determinantes (no dependerá tanto del tirador (pero esto es muy muy mínimo el efecto, casi negligible))
							ys[0] = ys[0] / 4

							teamsStats[p + 0].players[whoThrows].stats.throws++
							teamsStats[p + 0].players[whoThrows].inGameStats.throws++

							if (checkWhoWins(xs[whoThrows], ys[0])) {
								//SCORE

								//ha metido la bola, acabamos y contrarios empiezan jugada
								info.push(getRandomEventMessage('scoresThrow', teams, p, whoThrows, -1, lang));

								teamsStats[p + 0].players[whoThrows].stats.goals++;
								teamsStats[!p + 0].players[0].stats.concededGoals++;
								teamsStats[p + 0].players[whoThrows].inGameStats.goals++;
								teamsStats[!p + 0].players[0].inGameStats.concededGoals++;

								if (whoAssists == -1) {
									//ha sido de rebote, no hay asistencia
								} else if (whoAssists == whoThrows) {
									//ha sido un regate
									info.push(getRandomEventMessage('afterScoreDribble', teams, p, whoAssists, -1, lang));

									teamsStats[p + 0].players[whoThrows].stats.dribbles++
									teamsStats[p + 0].players[whoThrows].inGameStats.dribbles++
								} else {
									//ha sido asistencia
									info.push(getRandomEventMessage('afterScoreAssist', teams, p, whoAssists, -1, lang));

									teamsStats[p + 0].players[whoAssists].stats.assists++
									teamsStats[p + 0].players[whoAssists].inGameStats.assists++
								}

								puntuacion[p + 0] += 10;
								bolaMoviendose = false;
							} else {
								//MISS BALL

								info.push(getRandomEventMessage('throwSaved', teams, p, whoThrows, 0, lang));

								teamsStats[!p + 0].players[0].stats.saves++
								teamsStats[!p + 0].players[0].inGameStats.saves++

								//para portero, puede haber rebote
								//cazadores 1, 2 y 3
								xs[3] = getAverageByParameters(teams[p + 0].players[3], [0, 0.25, 1, 0.2, 0, 0, 0], [0, 0.05, 0.15], [0.05, 0.1], 0.2, felixFelicis[p + 0])
								xs[4] = getAverageByParameters(teams[p + 0].players[4], [0, 0.25, 1, 0.2, 0, 0, 0], [0, 0.05, 0.15], [0.05, 0.1], 0.2, felixFelicis[p + 0])
								xs[5] = getAverageByParameters(teams[p + 0].players[5], [0, 0.25, 1, 0.2, 0, 0, 0], [0, 0.05, 0.15], [0.05, 0.1], 0.2, felixFelicis[p + 0])
								xs[3] = coefAttack[3] * xs[3]
								xs[4] = coefAttack[4] * xs[4]
								xs[5] = coefAttack[5] * xs[5]

								//contrarios
								//cazadores 3, 2 y 1
								ys[5] = getAverageByParameters(teams[!p + 0].players[5], [0, 0.35, 1, 0.2, 0, 0, 0], [0, 0.05, 0.1], [0.1, 0], 0.2, felixFelicis[!p + 0])
								ys[4] = getAverageByParameters(teams[!p + 0].players[4], [0, 0.35, 1, 0.2, 0, 0, 0], [0, 0.05, 0.1], [0.1, 0], 0.2, felixFelicis[!p + 0])
								ys[3] = getAverageByParameters(teams[!p + 0].players[3], [0, 0.35, 1, 0.2, 0, 0, 0], [0, 0.05, 0.1], [0.1, 0], 0.2, felixFelicis[!p + 0])
								ys[5] = coefDefense[5] * ys[5]
								ys[4] = coefDefense[4] * ys[4]
								ys[3] = coefDefense[3] * ys[3]

								//guardian contrario
								ys[0] = getAverageByParameters(teams[!p + 0].players[0], [0, 0.35, 1, 0.1, 0, 0, 0], [0.05, 0.1, 0.1], [0, 0.1], 0.2, felixFelicis[!p + 0])
								ys[0] = coefDefense[0] * ys[0]

								//bludger x2
								theBludgers = bludgerViene(teams, p, felixFelicis, strategies);
								[info, teamsStats] = bludgerStatsAndTexts(theBludgers[0], info, teamsStats, teams, saveStatsInjured, lang);
								if(theBludgers[0].itHits && !theBludgers[0].itSaves){
									if (theBludgers[0].teamThatGetsHit) xs[theBludgers[0].whoGetsHit] = 0;
									else ys[theBludgers[0].whoGetsHit] = 0;
								}

								xsum = xs[3] + xs[4] + xs[5]
								ysum = (ys[5] + ys[4] + ys[3] + ys[0]) * 4

								if (checkWhoWins(xsum, ysum)) {
									//SIGUE LA JUGADA (REBOTE OFENSIVO)

									whoThrows = quienRobaElBalon(xs, [3, 4, 5]) ?? 0;

									info.push(getRandomEventMessage('offensiveRebound', teams, p, whoThrows, 0, lang));
									
									teamsStats[p + 0].players[whoThrows].stats.offensiveRebounds++
									teamsStats[p + 0].players[whoThrows].inGameStats.offensiveRebounds++

									whoAssists = -1

									//dejamos que vuelva a ejecutar el bucle
								} else {
									//BALON RECUPERADO 2 (REBOTE DEFENSIVO)

									//los contrarios cogen el rebote, y empiezan de cero

									let whoRecovers = quienRobaElBalon(ys, [5, 4, 3, 0]) ?? 0;

									info.push(getRandomEventMessage('defensiveRebound', teams, p, whoThrows, whoRecovers, lang));
									
									teamsStats[!p + 0].players[whoRecovers].stats.defensiveRebounds++
									teamsStats[!p + 0].players[whoRecovers].inGameStats.defensiveRebounds++

									bolaMoviendose = false
								}
							}

						} while (bolaMoviendose);
					} else {
						//todo penalti? aqui llega si le hacen falta cuando va a chutar (o antes de chutar mejor dicho)
						info.push(getRandomEventMessage('faultInThrow', teams, p, whoThrows, whoDefends, lang));
					}
				} else {
					//BALON RECUPERADO

					//los contrarios recuperan, y empiezan de cero
					let whoRecovers = quienRobaElBalon(ys, [5, 4, 3, 0]) ?? 0;

					//quien pierde el balón
					[xs[3], xs[4], xs[5]] = invertirProporcionalmente([xs[3], xs[4], xs[5]])
					let whoLostBall = quienRobaElBalon(xs, [3, 4, 5]) ?? 0;

					info.push(getRandomEventMessage('stealBeforeThrow', teams, p, whoLostBall, whoRecovers, lang));
					
					teamsStats[!p + 0].players[whoRecovers].stats.bStolen += 1
					teamsStats[p + 0].players[whoLostBall].stats.bLost += 1
					teamsStats[!p + 0].players[whoRecovers].inGameStats.bStolen += 1
					teamsStats[p + 0].players[whoLostBall].inGameStats.bLost += 1
				}
			}
		} else {
			//CONTRAATAQUE

			//los contrarios roban bola en campo contrario, contraataque
			//miramos quien roba bola, y el es el que chuta

			//no se por que, pero cuando esta funcion tiene un '?? 0' funciona normal, y si no lo tiene pues empieza a petar por todas partes

			//quien pierde el balón
			[xs[0], xs[3], xs[4], xs[5]] = invertirProporcionalmente([xs[0], xs[3], xs[4], xs[5]])
			let whoLostBall = quienRobaElBalon(xs, [0, 3, 4, 5]) ?? 0;
			let whoSteals = quienRobaElBalon(ys, [4, 5]) ?? 0;

			info.push(getRandomEventMessage('lostBallInArea', teams, p, whoLostBall, whoSteals, lang));
			
			teamsStats[!p + 0].players[whoSteals].stats.bStolen++
			teamsStats[p + 0].players[whoLostBall].stats.bLost++
			teamsStats[!p + 0].players[whoSteals].inGameStats.bStolen++
			teamsStats[p + 0].players[whoLostBall].inGameStats.bLost++

			//miramos si hay falta
			aboutFault = checkFault(teams[!p + 0].players[whoSteals], teams[p + 0].players[whoLostBall]);

			[info, puntuacion, teams, teamsStats] = faultStatsAndTexts(info, p, puntuacion, aboutFault, teams, whoSteals, whoLostBall, teamsStats, felixFelicis, saveStatsInjured, lang);

			if (!aboutFault.isFault) {
				//una vez descubrimos quien roba el balon, podemos cambiar la posesion, y se cambian las tornas, ahora los que han robado son xs, ya no ys
				p = !p

				//el que roba vs portero
				xs[whoSteals] = getAverageByParameters(teams[p + 0].players[whoSteals], [0.3, 0, 1, 0.2, 0, 0, 0], [0.15, 0, 0.1], [0, 0.05], 0.2, felixFelicis[p + 0])
				ys[0] = getAverageByParameters(teams[!p + 0].players[0], [0, 0.2, 1, 0.2, 0, 0, 0], [0.15, 0.15, 0.05], [0.05, 0], 0.2, felixFelicis[!p + 0])

				if (whoLostBall == 0) {
					info.push(getRandomEventMessage('gkTriesToSave', teams, p, whoLostBall, whoSteals, lang));
				} else {
					info.push(getRandomEventMessage('dfTriesToSave', teams, p, whoLostBall, whoSteals, lang));
				}
				teamsStats[p+0].players[whoSteals].stats.throws++
				teamsStats[p+0].players[whoSteals].inGameStats.throws++
				
				if (checkWhoWins(xs[whoSteals], ys[0])) {
					info.push(getRandomEventMessage('coolDribble', teams, p, whoSteals, 0, lang));
					puntuacion[p+0] += 10
					teamsStats[p+0].players[whoSteals].stats.goals++
					teamsStats[p+0].players[whoSteals].stats.dribbles++
					teamsStats[p+0].players[0].stats.concededGoals++
					teamsStats[p+0].players[whoSteals].inGameStats.goals++
					teamsStats[p+0].players[whoSteals].inGameStats.dribbles++
					teamsStats[p+0].players[0].inGameStats.concededGoals++
				} else {
					info.push(getRandomEventMessage('lastMomentSave', teams, p, whoSteals, 0, lang));
					teamsStats[!p+0].players[0].stats.saves++
					teamsStats[!p+0].players[0].inGameStats.saves++
				}
			}
		}

		if (jugadas > 20) {
			//BUSCANDO LA SNITCH

			//inicio buscar snitch
			xs[6] = getAverageByParameters(teams[0].players[6], [0, 0.025, 1, 0.025, 0, 0, 0], [0.35, 0.1, 0.2], [0.05, 0.05], 0.2, felixFelicis[p + 0])
			ys[6] = getAverageByParameters(teams[1].players[6], [0, 0.025, 1, 0.025, 0, 0, 0], [0.35, 0.1, 0.2], [0.05, 0.05], 0.2, felixFelicis[!p + 0])

			if (strategies[p + 0].seekTac === 2) {
				xs[0] = xs[0] * (xs[0] < ys[0] ? 0.8 : 1.2);
			} else if (strategies[p + 0].seekTac === 3) {
				xs[0] = xs[0] * (xs[0] <= ys[0] ? 1.2 : 0.8);
			}

			if (strategies[!p + 0].seekTac === 2) {
				ys[0] = ys[0] * (xs[0] <= ys[0] ? 1.2 : 0.8);
			} else if (strategies[!p + 0].seekTac === 3) {
				ys[0] = ys[0] * (xs[0] < ys[0] ? 0.8 : 1.2);
			}

			//vamos a ver que buscador gana el forcejeo
			let seekerSeeking = p + 0;
			if (!checkWhoWins(xs[0], ys[0])) {
				seekerSeeking = !seekerSeeking
			}

			const mediaBuscadorSeleccionado = getAverageByParameters(teams[seekerSeeking+0].players[6], [0, 0, 1, 0, 0, 0, 0], [0.4, 0.2, 0.2], [0, 0], 0.2, felixFelicis[p + 0])

			if (checkWhoWins(mediaBuscadorSeleccionado, 2000)) {
				//encontrada la snitch
				info.push(<Text>{"\n"}</Text>)
				info.push(getRandomEventMessage('snitchCaptured', teams, seekerSeeking, 6, 6, lang));
				puntuacion[seekerSeeking+0] += 150;
				teamsStats[seekerSeeking+0].players[6].stats.snitchs++
				teamsStats[seekerSeeking+0].players[6].inGameStats.snitchs++
				finPartido = true;
			}

			//que nadie la ha encontrado
			//fin buscar snitch

			if (jugadas > 100) {
				//terminamos el partido, demasiado largo ya
				info.push(<Text>{"\n"}</Text>)
				info.push(getRandomEventMessage('gameEnds', teams, p, -1, -1, lang));
				finPartido = true
			}
		}

		//desgaste por resistencia (tiene que ser a partir de la 20, pues las primeras jugadas no hay desgaste)
		//aprovechamos y sumamos jugadas (1 jugada = 1 minuto en partido)
		for (let i = 0; i < 7; i++) {
			for (let j = 0; j < 4; j++) {
				let recoverySkill = (teams[p + 0].players[i].skills[j] * ((0.04 * (teams[p + 0].players[i].skills[4] / 100)) + 0.95)).toFixed(2)
				if(recoverySkill < 1) recoverySkill = 1
				teams[p + 0].players[i].skills[j] = recoverySkill
				let recoverySkillE = (teams[!p + 0].players[i].skills[j] * ((0.04 * (teams[!p + 0].players[i].skills[4] / 100)) + 0.95)).toFixed(2)
				if(recoverySkillE < 1) recoverySkillE = 1
				teams[!p + 0].players[i].skills[j] = recoverySkillE
			}
			teamsStats[p+0].players[i].stats.jugadas++;
			teamsStats[p+0].players[i].inGameStats.jugadas++;
			teamsStats[!p+0].players[i].stats.jugadas++;
			teamsStats[!p+0].players[i].inGameStats.jugadas++;
		}
		for (let i = 7; i < 14; i++) {
			for (let j = 0; j < 4; j++) {
				let recoverySkill = (teams[p + 0].players[i].skills[j] * ((0.06 * (teams[p + 0].players[i].skills[4] / 100)) + 0.95)).toFixed(2)
				if(recoverySkill > 99) recoverySkill = 99
				teams[p + 0].players[i].skills[j] = recoverySkill

				let recoverySkillE = (teams[!p + 0].players[i].skills[j] * ((0.06 * (teams[!p + 0].players[i].skills[4] / 100)) + 0.95)).toFixed(2)
				if(recoverySkillE > 99) recoverySkillE = 99
				teams[!p + 0].players[i].skills[j] = recoverySkill
			}
		}

		//cambios para que los jugadores descansen
		if (!finPartido && jugadas !== 0 && jugadas % 5 === 0) {
			//TODO los cambios parece que no se hacen bien
			const changesConditions = [
				{ changes: 1, titularesModulo: 35, suplentesModulo: 15 },
				{ changes: 2, titularesModulo: 25, suplentesModulo: 25 },
				{ changes: 3, titularesModulo: 45, suplentesModulo: 5 }
			];

			for (const element of changesConditions) {
				if (strategies[p+0].changes === element.changes && (suplentesEnElCampo[p+0] ? (jugadas%element.suplentesModulo === 0) : (jugadas%element.titularesModulo === 0))) {
					info.push(getRandomEventMessage('gonnaBeChanges', teams, p, -1, -1, lang));

					for (let i = 0; i < 7; i++) {
						[info, teams[p+0], teamsStats[p+0], saveStatsInjured] = substitutePlayer(info, teams, i, teamsStats[p+0], saveStatsInjured, (p+0), lang, true);
					}
					suplentesEnElCampo[p+0] = !suplentesEnElCampo[p+0];
				}
				if (strategies[!p+0].changes === element.changes && (suplentesEnElCampo[!p+0] ? (jugadas%element.suplentesModulo === 0) : (jugadas%element.titularesModulo === 0))) {
					info.push(getRandomEventMessage('gonnaBeChanges', teams, !p, -1, -1, lang));
					
					for (let i = 0; i < 7; i++) {
						[info, teams[!p+0], teamsStats[!p+0], saveStatsInjured] = substitutePlayer(info, teams, i, teamsStats[!p+0], saveStatsInjured, (!p+0), lang, true);
					}
					suplentesEnElCampo[!p+0] = !suplentesEnElCampo[!p+0];
				}
			}
		}

		//todo informaciones de "muñeca caliente", "doble-doble", etc.


		//INFO PRINT
		info.push(<Text style={styles.matchScoreboard}>{puntuacion[0]} - {puntuacion[1]}</Text>)
		info.push(<Text>{"\n"}</Text>)

		//COMPROBACIONES FINALES PARTIDO

		if (finPartido) {
			if (puntuacion[0] == puntuacion[1]) {
				//han empatado, penalties
				info.push(<Text>{"\n"}</Text>)
				info.push(getRandomEventMessage('drawInfo', teams, p, -1, -1, lang));
				info.push(<Text>{"\n"}</Text>)
				const indicesQueChutanPen = [5, 4, 3]
				let indicePen = 0;

				do {
					//se juega muerte subita, si alguien falla y el otro mete, se acaba
					let mete1 = true;
					[mete1, info, teamsStats] = penalti(teams[0].players[indicesQueChutanPen[indicePen % 3]], indicesQueChutanPen[indicePen % 3], teams[1].players[0], info, felixFelicis[0], felixFelicis[1], teamsStats, 0, teams, lang)
					if (mete1) puntuacion[0] += 10

					let mete2 = true;
					[mete2, info, teamsStats] = penalti(teams[1].players[indicesQueChutanPen[indicePen % 3]], indicesQueChutanPen[indicePen % 3], teams[0].players[0], info, felixFelicis[1], felixFelicis[0], teamsStats, 1, teams, lang)
					if (mete2) puntuacion[1] += 10

					indicePen++;
					info.push(<Text style={styles.matchScoreboard}>{puntuacion[0]} - {puntuacion[1]}</Text>)
					info.push(<Text>{"\n"}</Text>)
				} while (puntuacion[0] == puntuacion[1]);

				info.push(getRandomEventMessage('weHaveAWinner', teams, p, -1, -1, lang));
			}

			let winner = puntuacion[0] > puntuacion[1] ? 0 : 1

			info.push(getRandomEventMessage('whoHasWon', teams, winner, -1, -1, lang));
		}


		// PARA SIGUIENTE JUGADA

		jugadas++;
		p = !p;

	} while (!finPartido)


	//estadísticas del partido
	let estadisticas = [{players:[],name:teams[0].name},{players:[],name:teams[1].name}]

	//sumamos el partido jugado y tal

	for (let i = 0; i < 2; i++) {
		for ( let j = 0; j < 14; j++){
			if (saveStatsInjured[i] && saveStatsInjured[i][j] && Object.keys(saveStatsInjured[i][j]).length != 0) {
				//hay jugador en recamara
				teamsStats[i].players[j] = saveStatsInjured[i][j]
			}

			if (unofficialDictionary[i][j] && Object.keys(unofficialDictionary[i][j]).length != 0) {
				//no es partido de liga/copa
				teamsStats[i].players[j].stats = unofficialDictionary[i][j].savedStats
				teamsStats[i].players[j].injury = unofficialDictionary[i][j].savedInjury
			}

			//sumamos a partidos totales, para entrenos (liga y copa)
			if (props.state == 1 || props.state == 2) {
				if (j%7 == 0) teamsStats[i].players[j].stats.gAsKeeper++
				else if (j%7 == 1 || j%7 == 2) teamsStats[i].players[j].stats.gAsBeater++
				else if (j%7 == 3 || j%7 == 4 || j%7 == 5) teamsStats[i].players[j].stats.gAsChaser++
				else teamsStats[i].players[j].stats.gAsSeeker++
			}

			//sumamos partidos de liga
			if (props.state == 1) {
				if (j%7 == 0) teamsStats[i].players[j].stats.gamesLeague.gAsKeeper++
				else if (j%7 == 1 || j%7 == 2) teamsStats[i].players[j].stats.gamesLeague.gAsBeater++
				else if (j%7 == 3 || j%7 == 4 || j%7 == 5) teamsStats[i].players[j].stats.gamesLeague.gAsChaser++
				else teamsStats[i].players[j].stats.gamesLeague.gAsSeeker++
			}

			//anadimos estadisticas del partido
			estadisticas[i].players[j] = teamsStats[i].players[j];
		}
	}
	//SE METE ALL LO QUE HA OCURRIDO EN EL PARTIDO EN EL ARRAY OFICIAL QUE SE GUARDA
	data.teams[team1Id].players.splice(0, 14, ...teamsStats[0].players);
	data.teams[team2Id].players.splice(0, 14, ...teamsStats[1].players);

	return [data, info, puntuacion, estadisticas];
}

function penalti(tirador, tiradorNum, portero, info, felixTirador, felixPortero, teamsStats, p, teams, lang) {
	info.push(getRandomEventMessage('beforeShotPenalty', teams, p, tiradorNum, 0, lang));

	const tiradorHabilidad = getAverageByParameters(tirador, [0.4, 0.05, 1, 0.05, 0, 0, 0], [0.1, 0.05, 0.15], [0, 0], 0.2, felixTirador);

	const porteroHabilidad = getAverageByParameters(tirador, [0, 0.4, 1, 0.1, 0, 0, 0], [0.2, 0.1, 0], [0, 0], 0.2, felixPortero);

	const percentageOfScoring = (((tiradorHabilidad) / ((tiradorHabilidad) + (porteroHabilidad))) * 65) + 35
	//percentageOfScoring es un numero del 1 al 100, con la probabilidad del tirador de meter. Cuanta mas diferencia entre *X+Y, menos suerte hay. if (x > y) menos suerte

	teamsStats[p + 0].players[tiradorNum].stats.throws++
	teamsStats[p + 0].players[tiradorNum].inGameStats.throws++

	if (percentageOfScoring > generateRandomNumber(1, 99)) {
		//penalti metido
		teamsStats[p + 0].players[tiradorNum].stats.goals++
		teamsStats[p + 0].players[tiradorNum].inGameStats.goals++
		teamsStats[!p + 0].players[0].stats.concededGoals++
		teamsStats[!p + 0].players[0].inGameStats.concededGoals++

		info.push(getRandomEventMessage('penaltyScored', teams, p, tiradorNum, 0, lang));
		
		return [true, info, teamsStats]
	}

	teamsStats[!p + 0].players[0].stats.saves++
	teamsStats[!p + 0].players[0].inGameStats.saves++

	info.push(getRandomEventMessage('penaltyFailed', teams, p, tiradorNum, 0, lang));

	return [false, info, teamsStats];
}

function bludgerViene(teams, p, felix, strategies, partOfField = 0) {
	//la idea de esta función es llamarla cada vez que una bludger se acerque. Se puede dar el caso que la bludger pase de largo
	//siempre haremos esta funcion dos veces (mejor un bucle dentro de la funcion), pues hay dos bludgers, y para que afecte mas
	//part of field es para ver donde se encuentran del campo (respecto a la posesion), porque dependiendo de las tacticas (strategies) podrán afectar mas o menos los bateadores
	//partOfField 1 -> Primera mitad del campo; 2 -> Segunda mitad; 3 -> all el campo (buscadores)

	let lasBludgers = [
		{itHits:false,itSaves:false,teamThatGetsHit:!p,whichBeaterHits:0,whichBeaterSaves:0,causesInjury:0,whoGetsHit:0},
		{itHits:false,itSaves:false,teamThatGetsHit:!p,whichBeaterHits:0,whichBeaterSaves:0,causesInjury:0,whoGetsHit:0}
	]
	
	for (let i = 0; i < 2; i++) {
		//primero se mira si la bludger pasa de largo, o no está disponible (está lejos, o distraida con otras cosas/personas)
		//coefBeat son los coeficientes, el primer hueco es el equipo, y el primer jugador el primer jugador (duh)
		let coefBeat = [[0.5, 0.5], [0.5, 0.5]]
		if (partOfField == 0 && strategies[p+0].beaters == 2) {
			//primera mitad campo && 0-2
			coefBeat[p+0] = [0.4, 0.4]
		} else if (partOfField == 0 && strategies[p+0].beaters == 3) {
			//primera mitad && 2-0
			coefBeat[p+0] = [0.6, 0.6]
		} else if (partOfField == 1 && strategies[p+0].beaters == 2) {
			coefBeat[p+0] = [0.6, 0.6]
		} else if (partOfField == 1 && strategies[p+0].beaters == 3) {
			coefBeat[p+0] = [0.4, 0.4]
		}
		//same, pero para enemigo (pero al reves)
		if (partOfField == 0 && strategies[!p+0].beaters == 2) coefBeat[!p+0] = [0.6, 0.6]
		else if (partOfField == 0 && strategies[!p+0].beaters == 3) coefBeat[!p+0] = [0.4, 0.4]
		else if (partOfField == 1 && strategies[!p+0].beaters == 2) coefBeat[!p+0] = [0.4, 0.4]
		else if (partOfField == 1 && strategies[!p+0].beaters == 3) coefBeat[!p+0] = [0.6, 0.6]


		let beatersteam1 = [
			getAverageByParameters(teams[p + 0].players[1], [0, 0.2, 1, 0, 0, 0, 0.4], [0, 0.1, 0.1], [0, 0], 0.2, felix[p + 0]) * coefBeat[p+0][0],
			getAverageByParameters(teams[p + 0].players[2], [0, 0.2, 1, 0, 0, 0, 0.4], [0, 0.1, 0.1], [0, 0], 0.2, felix[p + 0]) * coefBeat[p+0][1]
		]
		
		let beatersteam2 = [
			getAverageByParameters(teams[!p + 0].players[1], [0, 0.15, 1, 0.05, 0, 0.35, 0.05], [0.1, 0.05, 0.05], [0, 0], 0.2, felix[!p + 0]) * coefBeat[!p+0][0],
			getAverageByParameters(teams[!p + 0].players[2], [0, 0.15, 1, 0.05, 0, 0.35, 0.05], [0.1, 0.05, 0.05], [0, 0], 0.2, felix[!p + 0]) * coefBeat[!p+0][1]
		]

		//si el segundo numero es 4: la bludger nunca se encontrará, si es 396: siempre se encontrará, y si es 200 se encontrará el 50% de las veces
		if (checkWhoWins(beatersteam1[0]+beatersteam1[1]+beatersteam2[0]+beatersteam2[1],250)) {
			//hay bludger
			lasBludgers[i].itHits = true;

			//puede ser lesion, si no se golpea a nadie, la reseteamos
			if (generateRandomNumber(1,999) < 7) {
				//lesion
				lasBludgers[i].causesInjury = 2
			}

			//miramos quien la golpeará
			if (checkWhoWins(beatersteam2[0]+beatersteam2[1],beatersteam1[0]+beatersteam1[1])) {
				//tira el equipo contrario (a nuestros atacantes)
				lasBludgers[i].teamThatGetsHit = p
				beatersteam1[0] = getAverageByParameters(teams[p + 0].players[1], [0, 0.1, 1, 0.3, 0, 0, 0], [0, 0.1, 0.2], [0, 0.1], 0.2, felix[p + 0]) * coefBeat[p+0][0]
				beatersteam1[1] = getAverageByParameters(teams[p + 0].players[2], [0, 0.1, 1, 0.3, 0, 0, 0], [0, 0.1, 0.2], [0, 0.1], 0.2, felix[p + 0]) * coefBeat[p+0][1]
				beatersteam2[0] = getAverageByParameters(teams[!p + 0].players[1], [0.1, 0, 1, 0.3, 0, 0, 0], [0, 0.1, 0.15], [0.1, 0.05], 0.2, felix[!p + 0]) * coefBeat[!p+0][0]
				beatersteam2[1] = getAverageByParameters(teams[!p + 0].players[2], [0.1, 0, 1, 0.3, 0, 0, 0], [0, 0.1, 0.15], [0.1, 0.05], 0.2, felix[!p + 0]) * coefBeat[!p+0][1]

				//vemos qué golpeador golpea
				lasBludgers[i].whichBeaterHits = quienRobaElBalon([0, beatersteam2[0], beatersteam2[1], 0, 0, 0, 0], [1, 2]) ?? 0;

				//vemos qué golpeador salva
				lasBludgers[i].whichBeaterSaves = quienRobaElBalon([0, beatersteam1[0], beatersteam1[1], 0, 0, 0, 0], [1, 2]) ?? 0;

				//sabemos quien la tira, pero vamos a ver si pueden defenderla
				if (checkWhoWins(beatersteam2[lasBludgers[i].whichBeaterHits],beatersteam1[lasBludgers[i].whichBeaterSaves])) {
					//no pueden defenderla, golpeará a alguien
					lasBludgers[i].itSaves = false;

					//a quien golpea
					const unoDeTres = generateRandomNumber(1,12)
					if (partOfField == 1) {
						if (unoDeTres <= 5) lasBludgers[i].whoGetsHit = 3
						else if (unoDeTres <= 9) lasBludgers[i].whoGetsHit = 4
						else lasBludgers[i].whoGetsHit = 5
					} else if (partOfField == 2) {
						if (unoDeTres <= 5) lasBludgers[i].whoGetsHit = 5
						else if (unoDeTres <= 9) lasBludgers[i].whoGetsHit = 4
						else lasBludgers[i].whoGetsHit = 3
					} else {
						//buscadores
						lasBludgers[i].whoGetsHit = 6
					}
				} else {
					//la despejan, se informa, y acaba everything
					lasBludgers[i].itSaves = true;
					lasBludgers[i].whoGetsHit = 0;
					lasBludgers[i].causesInjury = 0;
				}
			} else {
				//tira el equipo con posesion (a sus defensas)
				//es lo mismo que lo anterior (//todo simplificar)
				lasBludgers[i].teamThatGetsHit = !p
				beatersteam1[0] = getAverageByParameters(teams[p + 0].players[1], [0.1, 0.05, 1, 0.3, 0, 0, 0], [0, 0.1, 0.15], [0.05, 0.05], 0.2, felix[p + 0]) * coefBeat[p+0][0]
				beatersteam1[1] = getAverageByParameters(teams[p + 0].players[2], [0.1, 0.05, 1, 0.3, 0, 0, 0], [0, 0.1, 0.15], [0.05, 0.05], 0.2, felix[p + 0]) * coefBeat[p+0][1]
				beatersteam2[0] = getAverageByParameters(teams[!p + 0].players[1], [0, 0.05, 1, 0.35, 0, 0, 0], [0.05, 0.1, 0.15], [0.05, 0.05], 0.2, felix[!p + 0]) * coefBeat[!p+0][0]
				beatersteam2[1] = getAverageByParameters(teams[!p + 0].players[2], [0, 0.05, 1, 0.35, 0, 0, 0], [0.05, 0.1, 0.15], [0.05, 0.05], 0.2, felix[!p + 0]) * coefBeat[!p+0][1]
			
				lasBludgers[i].whichBeaterHits = quienRobaElBalon([0, beatersteam2[0], beatersteam2[1], 0, 0, 0, 0], [1, 2]) ?? 0;
				lasBludgers[i].whichBeaterSaves = quienRobaElBalon([0, beatersteam1[0], beatersteam1[1], 0, 0, 0, 0], [1, 2]) ?? 0;

				if (checkWhoWins(beatersteam2[lasBludgers[i].whichBeaterHits],beatersteam1[lasBludgers[i].whichBeaterSaves])) {
					lasBludgers[i].itSaves = false;

					const unoDeTres = generateRandomNumber(1,12)
					if (partOfField == 1) {
						if (unoDeTres <= 5) lasBludgers[i].whoGetsHit = 3
						else if (unoDeTres <= 9) lasBludgers[i].whoGetsHit = 4
						else lasBludgers[i].whoGetsHit = 5
					} else if (partOfField == 2) {
						if (unoDeTres <= 5) lasBludgers[i].whoGetsHit = 5
						else if (unoDeTres <= 9) lasBludgers[i].whoGetsHit = 4
						else lasBludgers[i].whoGetsHit = 3
					} else lasBludgers[i].whoGetsHit = 6
				} else {
					lasBludgers[i].itSaves = true;
					lasBludgers[i].whoGetsHit = 0;
					lasBludgers[i].causesInjury = 0;
				}
			}
		} else {
			//bludger pasa de largo, o no está
			lasBludgers[i].itHits = false;
		}
	}

	return lasBludgers;
}

function bludgerStatsAndTexts(aboutBludger, info, teamsStats, teams, saveStatsInjured, lang) {
	if (aboutBludger.itHits) {
		//se golpea a alguien
		teamsStats[!aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterHits].stats.bludgersThrown++
		teamsStats[!aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterHits].inGameStats.bludgersThrown++

		if (!aboutBludger.itSaves) {
			//golpea a alguien
			info.push(getRandomEventMessage('bludgerHits', teams, aboutBludger.teamThatGetsHit, aboutBludger.whoGetsHit, aboutBludger.whichBeaterHits, lang));

			teamsStats[!aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterHits].stats.bludgersHit++
			teamsStats[!aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterHits].inGameStats.bludgersHit++
		} else {
			//la salva
			info.push(getRandomEventMessage('bludgerSaves', teams, aboutBludger.teamThatGetsHit, aboutBludger.whichBeaterSaves, aboutBludger.whichBeaterHits, lang));
		
			teamsStats[aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterSaves].stats.bludgersSaves++
			teamsStats[aboutBludger.teamThatGetsHit + 0].players[aboutBludger.whichBeaterSaves].inGameStats.bludgersSaves++
		}

		if (aboutBludger.causesInjury > 0) {
			info.push(getRandomEventMessage('bludgerInjures', teams, aboutBludger.teamThatGetsHit, aboutBludger.whoGetsHit, aboutBludger.whichBeaterHits, lang));

			teamsStats[aboutBludger.teamThatGetsHit+0].players[aboutBludger.whoGetsHit].injury = parseInt(aboutBludger.injury);
			[info, teams[aboutBludger.teamThatGetsHit+0], teamsStats[aboutBludger.teamThatGetsHit+0], saveStatsInjured] = substitutePlayer(info, teams, aboutBludger.whoGetsHit, teamsStats[aboutBludger.teamThatGetsHit+0], saveStatsInjured, (aboutBludger.teamThatGetsHit+0), lang);
		}
	}

	return [info, teamsStats]
}

function checkFault(aggressor, victim, isInAttack = false) {
	let isFault = false, injury = 0, isPenalty = false, isFlagrant = false, isExpulsion = false;

	const pointsFault = generateRandomNumber(0, 100)
	const seedForRandom = isInAttack ? 200 : 100
	const miNumAleatorio = (generateRandomNumber(0, seedForRandom) / 100)

	if (miNumAleatorio < ((aggressor.hiddenSkills[0]) * 0.25 / 100)) {
		isFault = true;

		//miramos si se lesiona, y cuantas semanas
		let probabilidadLesion = generateRandomNumber(0, 1000, 1)
		let paraAtac = aggressor.hiddenSkills[0] / 10
		let paraDef = ((victim.skills[3] + (victim.age - 40) * (-6)) * 10) / (231)
		//if(buscador) if(probabilidadLesion < 25) probabilidadLesion += 15
		probabilidadLesion += (paraDef - paraAtac)
		probabilidadLesion = probabilidadLesion * 4

		if (probabilidadLesion < 15) {
			//paraDef es un numero del 0 al 10
			if (probabilidadLesion > 10) injury = 0
			else if (probabilidadLesion > 5) injury = 1
			else injury = 2
		}

		//check penalty
		if (pointsFault >= 70) isPenalty = true

		//check flagrant
		if (pointsFault >= 90) isFlagrant = true

		//check expulsion
		if (pointsFault >= 95) isExpulsion = true
	}

	return {
		isFault: isFault, //si hay falta o no (boleano)
		injury: injury, //si hay lesión o no (number, de la cantidad de semanas)
		isPenalty: isPenalty, //si hay penalti (boleano)
		isFlagrant: isFlagrant, //si es antideportiva (boleano)
		isExpulsion: isExpulsion //si hay expulsión (boleano)
	}
}

function faultStatsAndTexts(info, p, puntuacion, aboutFault, teams, whoIsVictim, whoCommitsFault, teamsStats, felixFelicis, saveStatsInjured, lang, isInAttack = false) {
	//(arreglado, pero cuidado con los parseInt()) parece que esta funcion va rara, si se comentan los info y los substitute player funciona (el primer info dobe siempre funciona)
	if (aboutFault.isFault) {
		if (!isInAttack) info.push(getRandomEventMessage('commitsFault', teams, p, whoIsVictim, whoCommitsFault, lang));
		else info.push(getRandomEventMessage('commitsFaultInAttack', teams, p, whoCommitsFault, whoIsVictim, lang));

		const teamWhoSteals = (isInAttack ? p : !p) + 0;
		teamsStats[teamWhoSteals].players[whoIsVictim].stats.faults++
		teamsStats[teamWhoSteals].players[whoIsVictim].inGameStats.faults++
		
		//si tiene mas de 7 faltas, se le expulsa
		if (teamsStats[teamWhoSteals].players[whoIsVictim].inGameStats.faults >= 7) {
			//expulsion por 7 faltas
			info.push(getRandomEventMessage('expulsion7Faults', teams, teamWhoSteals, whoIsVictim, whoCommitsFault, lang));
			
			teamsStats[teamWhoSteals].players[whoIsVictim].stats.expulsions = parseInt(1) + parseInt(teamsStats[teamWhoSteals].players[whoIsVictim].stats.expulsions);
			teamsStats[teamWhoSteals].players[whoIsVictim].inGameStats.expulsions = parseInt(1);

			[info, teams[teamWhoSteals], teamsStats[teamWhoSteals], saveStatsInjured] = substitutePlayer(info, teams, whoIsVictim, teamsStats[teamWhoSteals], saveStatsInjured, teamWhoSteals, lang);
		}


		if (aboutFault.injury > 0) {
			info.push(getRandomEventMessage('isInjuredByFault', teams, p, whoIsVictim, whoCommitsFault, lang));

			teamsStats[!teamWhoSteals+0].players[whoCommitsFault].injury = parseInt(1) + parseInt(aboutFault.injury);

			[info, teams[p+0], teamsStats[p+0], saveStatsInjured] = substitutePlayer(info, teams, whoCommitsFault, teamsStats[p+0], saveStatsInjured, (p+0), lang);
		}
		if (!isInAttack) {
			if (aboutFault.isFlagrant) {
				//antideportiva, se suman 30 pts
				info.push(getRandomEventMessage('isFlagrantFault', teams, teamWhoSteals, whoIsVictim, whoCommitsFault, lang));
				info.push(getRandomEventMessage('plus30ptsOfFlagrant', teams, teamWhoSteals, whoIsVictim, whoCommitsFault, lang));

				puntuacion[p] += 30
			}
			if (aboutFault.isPenalty) {
				info.push(getRandomEventMessage('beforePenaltyInfo', teams, teamWhoSteals, whoIsVictim, whoCommitsFault, lang));

				let mete = true;
				[mete, info, teamsStats] = penalti(teams[p + 0].players[5], 5, teams[!p + 0].players[0], info, felixFelicis[p + 0], felixFelicis[!p + 0], teamsStats, (p+0), teams, lang)
				if (mete) puntuacion[p] += 10
			}
			if (aboutFault.isExpulsion) {
				//expulsion roja directa
				info.push(getRandomEventMessage('ExpulsionDirectRedCard', teams, teamWhoSteals, whoIsVictim, whoCommitsFault, lang));
				
				//esto funciona, copiar
				teamsStats[teamWhoSteals].players[whoIsVictim].stats.expulsions = parseInt(1) + parseInt(teamsStats[teamWhoSteals].players[whoIsVictim].stats.expulsions);
				teamsStats[teamWhoSteals].players[whoIsVictim].inGameStats.expulsions = parseInt(1);

				[info, teams[teamWhoSteals], teamsStats[teamWhoSteals], saveStatsInjured] = substitutePlayer(info, teams, whoIsVictim, teamsStats[teamWhoSteals], saveStatsInjured, teamWhoSteals, lang);
			}
		}
	}

	return [info, puntuacion, teams, teamsStats]
}

function substitutePlayer(info, teams, playerToChange, teamsStats, saveStatsInjured, wichTeam, lang, massiveChanges = false) {
	let team = teams[wichTeam];
	if (teamsStats.players[playerToChange+7].injury <= 0 && teamsStats.players[playerToChange+7].inGameStats.faults < 7 && teamsStats.players[playerToChange+7].inGameStats.expulsions != 1) {
		//cambio estandar, suplente en condiciones
		const ply1 = {thsply: team.players[playerToChange]}
		team.players[playerToChange] = team.players[playerToChange+7]
		team.players[playerToChange+7] = ply1.thsply
		const ply1st = {thsply: teamsStats.players[playerToChange]}
		teamsStats.players[playerToChange] = teamsStats.players[playerToChange+7]
		teamsStats.players[playerToChange+7] = ply1st.thsply

		if (massiveChanges) info.push(getRandomEventMessage('exitEntersChange', teams, wichTeam, playerToChange+7, playerToChange, lang));
		else info.push(getRandomEventMessage('normalChange', teams, wichTeam, playerToChange+7, playerToChange, lang));
	} else if (teamsStats.players[playerToChange].injury <= 0 && teamsStats.players[playerToChange].inGameStats.faults < 7 && teamsStats.players[playerToChange].inGameStats.expulsions != 1) {
		//no hay suplente, pero puede seguir jugando
		info.push(getRandomEventMessage('noChangeStaysInField', teams, wichTeam, playerToChange, -1, lang));
	} else {
		//no hay suplente, y el titular no puede seguir jugando, entra FAN RANDOM

		//guardamos jugador en la recamara
		team.players[playerToChange] = playerEmptyObject("FAN RANDOM")
		const ply1 = {thsply: team.players[playerToChange]}
		const ply1st = {thsply: teamsStats.players[playerToChange]}
		if (teamsStats.players[playerToChange].name != "FAN RANDOM") saveStatsInjured[wichTeam][playerToChange] = ply1st.thsply;
		teamsStats.players[playerToChange] = ply1.thsply;

		info.push(getRandomEventMessage('entersFanRandom', teams, wichTeam, playerToChange, -1, lang));
	}

	return [info,team,teamsStats,saveStatsInjured]
}

function getRandomEventMessage(msgs, teams, p, x, y, lang) {
	//esta funcion escoge un mensaje aleatorio entre los que haya en el objeto de mensajes
	//msgs = mensajes posibles en formato array
	//teams = toda la info de los equipos, de ambos, para extraerla aqui
	//p = posesion del equipo
	//x = persona del equipo con posesion con el protagonismo del mensaje
	//y = persona del equipo sin posesion con el protagonismo del mensaje
	//lang = idioma en el que se quiere el mensaje

	//Tomamos el objeto del evento
	const messagesForEvent = eventMessages[msgs];
	if (!messagesForEvent) {
	  console.error(`No se han definido mensajes para el evento: "${msgs}"`);
	  return null;
	}
  
	//Buscamos el idioma específico
	const msgTemplates = messagesForEvent[lang];
	if (!msgTemplates || !Array.isArray(msgTemplates)) {
	  console.error(`No hay mensajes para el evento "${msgs}" en el idioma "${lang}"`);
	  return null;
	}

	// Elegir un mensaje al azar de entre las opciones disponibles
	const randomIndex = Math.floor(Math.random() * msgTemplates.length);
	const template = msgTemplates[randomIndex];

	// Preparar un objeto con every posible parámetro
	const params = {
		xTeamName: teams[p+0].name,
		yTeamName: teams[!p+0].name,
		xName: teams[p+0].players[x] ? teams[p+0].players[x].name : '',
		yName: (y !== null && teams[!p+0].players[y]) ? teams[!p+0].players[y].name : '',
		xNameSup: teams[p+0].players[y] ? teams[p+0].players[y].name : '',
		p
	};

	return template(params);
}

////////////////////////////////////funciones fuera del partido////////////////////////////////////

function checkWhoWins(x, y) {
	//x deberia ser el numero de los atacantes, e y el de los defensores
	//esto calculará quien gana la jugada
	return x / (x + y) > (generateRandomNumber(0, 100) / 100)
}
function generateRandomNumber(from, to, howMany = 1) {
	const diferencia = to - from + 1;
	let numbers = [];
	for (let i = 0; i < howMany; i++) {
		numbers[i] = Math.floor(Math.random() * diferencia + from);
	}
	if (howMany == 1) numbers = numbers[0]
	return numbers;
}
  
function getAverageByParameters(player, coefsk, coefbr, coefhs, coefluck, felfel) {
	//player -> el jugador y sus habilidades
	//coefsk -> coeficiente para cada skill
	//coefbr -> coeficiente para cada habilidad de la escoba
	//coefhs -> coeficiente para hidden skills
	//coefluck -> coeficiente de suerte
	//felfel -> integer que es 90 si tiene felix felicis, si no es 0
	//coefsk[0] + [1] + [3] + [5] + coefbr[0] + [1] + [2] + coefluck == 1
	if ((coefsk[0] + coefsk[1] + coefsk[3] + coefsk[5] + coefsk[6] + coefbr[0] + coefbr[1] + coefbr[2] + coefhs[0] + coefhs[1] + coefluck).toFixed(3) != 1) console.log("security check, there is an operation of coeficients not correctly calculated.\nPlayer: " + player.name + "\ncoefsk:" + coefsk + "\ncoefbr:" + coefbr + "\ncoefluck:" + coefluck)
	return (player.skills[0] * coefsk[0]
		+ player.skills[1] * coefsk[1]
		+ player.skills[3] * coefsk[3]
		+ player.skills[4] * coefsk[4]
		+ player.skills[5] * coefsk[5]
		+ player.skills[6] * coefsk[6]
		+ player.broom[0] * coefbr[0] * (player.skills[2] / 100)
		+ player.broom[1] * coefbr[2] * (player.skills[2] / 100)
		+ player.broom[1] * coefbr[2] * (player.skills[2] / 100)
		+ player.hiddenSkills[0] * coefhs[0]
		+ player.hiddenSkills[1] * coefhs[1]
		+ generateRandomNumber(felfel, 100) * coefluck)
}
function quienRobaElBalon(jugadores, queJugador) {
	//esta funcion devuelve un numero, que es el indice del jugador que roba el balon
	//jugadores = array xs o ys con la media de los jugadores en esa jugada (ya está el coeficiente multiplicado, es realmente al 100% lo que influyen en esa jugada)
	//queJugador = array con los indices de los jugadores que influyen, si hay dos y son el 4 y el 5, será [4,5], si hay 4 y son el 1, 3, 4 y 5 será [1,3,4,5]

	let sumaTotal = queJugador.reduce((acumulador, indice) => acumulador + jugadores[indice], 0);
	const randomForThrow = generateRandomNumber(0, sumaTotal)

	for (const element of queJugador) {
		sumaTotal -= jugadores[element]
		if (randomForThrow > sumaTotal) return element
	}

	return queJugador[queJugador.length - 1]
}
function invertirProporcionalmente(arr) {
	//esto es un poco para ver quien tiene la culpa
	//(el jugador menos involucrado en la jugada, está menos involucrado porque es mas malo, asi que ese jugador mas malo tendrá mas posibilidades de perder balon)
	const total = arr.reduce((acc, valor) => acc + valor, 0);
	return arr.map(valor => (total - valor) / (arr.length - 1));
}

//posibles fallos, si sale lo de Cannot create property '' on number '2' realmente tiene un problema con lo que se le pasa, hay que mirar de donde viene el 'number' y parsearlo (parseint()), o pasarselo de otra forma (.concat() en vez de .push())

export default partido
